import { render, staticRenderFns } from "./CalciatoreComparison.vue?vue&type=template&id=cf1c1830&scoped=true&"
import script from "./CalciatoreComparison.vue?vue&type=script&lang=js&"
export * from "./CalciatoreComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1c1830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf1c1830')) {
      api.createRecord('cf1c1830', component.options)
    } else {
      api.reload('cf1c1830', component.options)
    }
    module.hot.accept("./CalciatoreComparison.vue?vue&type=template&id=cf1c1830&scoped=true&", function () {
      api.rerender('cf1c1830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CalciatoreComparison.vue"
export default component.exports